import { Button, Grid, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useShowSnackbar } from 'components/main/SnackbarProvider';
import React, { FC, useState } from 'react';
import { googleSignIn, isUserSignedUp } from 'services/AccountService';
import AccountSignupForm from './AccountSignupForm';

const AccountSignup: FC = () => {
  const showSnackbar = useShowSnackbar();
  const [user, setUser] = useState<firebase.User | undefined>();

  async function handleLoginClick() {
    try {
      const user = await googleSignIn();
      if (user.user) {
        const isAlreadySignedUp = await isUserSignedUp(user.user.uid);
        if (isAlreadySignedUp) {
          showSnackbar(
            <Alert severity="info">This email address has already signed up for an account.</Alert>,
          );
        } else {
          setUser(user.user ?? undefined);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  if (user) {
    return <AccountSignupForm user={user} name={user.displayName ?? ''} email={user.email ?? ''} />;
  }

  return (
    <Grid justify="center" spacing={2} container>
      <Grid item>
        <Typography gutterBottom>
          Sign up for an account to start submitting lessons to the MNCodes Integrated Curriculum
          and Professional Development Resource Library.
        </Typography>
        <Typography gutterBottom>
          To get started, login with a Google account. After signup, this Google account will be
          used to login to your account.
        </Typography>
      </Grid>
      <Grid item>
        <Button onClick={handleLoginClick} variant="contained" color="primary">
          Login with Google
        </Button>
      </Grid>
    </Grid>
  );
};

export default AccountSignup;
